import React, { createContext, useContext, useState } from 'react';

const RippleContext = createContext();

export const RippleProvider = ({ children }) => {
  const [rippleEnabled, setRippleEnabled] = useState(true);
  
  return (
    <RippleContext.Provider value={{ rippleEnabled, setRippleEnabled }}>
      {children}
    </RippleContext.Provider>
  );
};

export const useRipple = () => {
  const context = useContext(RippleContext);
  if (!context) {
    return { rippleEnabled: true, setRippleEnabled: () => {} };
  }
  return context;
};

export default RippleContext;
